/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SetCaptureLabelRequest
 */
export interface SetCaptureLabelRequest {
    /**
     * 
     */
    captureIds: Array<string>;
    /**
     * 
     */
    labelId: string;
    /**
     * 
     */
    applied: boolean;
}

/**
 * Check if a given object implements the SetCaptureLabelRequest interface.
 */
export function instanceOfSetCaptureLabelRequest(value: object): value is SetCaptureLabelRequest {
    if ((!('captureIds' in (value as Record<string, any>)) && !('capture_ids' in (value as Record<string, any>))) || ((value as Record<string, any>)['captureIds'] === undefined && (value as Record<string, any>)['capture_ids'] === undefined)) return false;
    if ((!('labelId' in (value as Record<string, any>)) && !('label_id' in (value as Record<string, any>))) || ((value as Record<string, any>)['labelId'] === undefined && (value as Record<string, any>)['label_id'] === undefined)) return false;
    if (!('applied' in value) || value['applied'] === undefined) return false;
    return true;
}

export function SetCaptureLabelRequestFromJSON(json: any): SetCaptureLabelRequest {
    return SetCaptureLabelRequestFromJSONTyped(json, false);
}

export function SetCaptureLabelRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SetCaptureLabelRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'captureIds': json['capture_ids'],
        'labelId': json['label_id'],
        'applied': json['applied'],
    };
}

export function SetCaptureLabelRequestToJSON(json: any): SetCaptureLabelRequest {
    return SetCaptureLabelRequestToJSONTyped(json, false);
}

export function SetCaptureLabelRequestToJSONTyped(value?: SetCaptureLabelRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'capture_ids': value['captureIds'],
        'label_id': value['labelId'],
        'applied': value['applied'],
    };
}

